import "./app.scss";
import ServiceForm from "./components/ServiceForm";
import desktop from "./assets/images/Desktop.jpg";
import mobile from "./assets/images/Mobile.jpg";
import { useState } from "react";
import "./assets/scss/cconsent-bar.css";

function App() {
    const [success, setSuccess] = useState(false);

    return (
        <>
            <nav className="header">
                <div className="top-row">
                    <a
                        className="logo-wrapper"
                        href="https://www.skoda.pl/"
                        target="_self"
                    ></a>
                </div>
                <div className="bottom-row">
                    <a href="https://www.skoda.pl/" target="_self">
                        Przejdź do&nbsp;strony głównej
                    </a>
                </div>
            </nav>
            <div className="main-container">
                <div className="main-image">
                    <img src={desktop} className="background-image" alt="" />
                    <img
                        src={mobile}
                        className="background-image-mobile"
                        alt=""
                    />
                </div>
                <div
                    className={`form-outer-container ${success ? "form-outer-container--message" : ""}`}
                >
                    <div className="form-bg">
                        {!success ? (
                            <ServiceForm setSuccess={setSuccess} />
                        ) : (
                            <div className="form-container">
                                <div className="form-row">
                                    <div className="form-copy">
                                        <h2>DZIĘKUJEMY!</h2>
                                        <p>
                                            Wysłaliśmy do Ciebie e-mail z prośbą
                                            o potwierdzenie chęci zapisu.
                                            <br />
                                            Kliknij przycisk w wiadomości, aby
                                            potwierdzić.
                                        </p>
                                        <br />
                                        <div className="form-row form-row--buttons">
                                            <a
                                                href="./"
                                                className="button button--primary"
                                                style={{
                                                    textDecoration: "none",
                                                    display: "inline-block",
                                                    textAlign: "center",
                                                    width: "100%",
                                                }}
                                            >
                                                Wróć do strony głównej
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default App;
